import { render, staticRenderFns } from "./AddendaInlineTable.vue?vue&type=template&id=25d62990&scoped=true"
import script from "./AddendaInlineTable.vue?vue&type=script&lang=js"
export * from "./AddendaInlineTable.vue?vue&type=script&lang=js"
import style0 from "./AddendaInlineTable.vue?vue&type=style&index=0&id=25d62990&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d62990",
  null
  
)

export default component.exports